import clsx from "clsx";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import classes from "./Relics.module.css";
import { RelicsIcon } from "./RelicsIcon";

interface RelicsProps {
  fullWidth?: boolean;
  value: number | null | undefined;
}

export const Relics = (props: RelicsProps) => {
  const { fullWidth, value } = props;

  const { t } = useTranslation();
  const formattedValue = useMemo(() => {
    if (typeof value === "undefined" || value === null) {
      return undefined;
    } else {
      return String(t("Relics.value", { value }));
    }
  }, [t, value]);

  return (
    <span
      className={clsx(classes.root, {
        [classes.fullWidth]: fullWidth,
        [classes.negative]: (value ?? 0) < 0,
      })}
    >
      {typeof formattedValue === "undefined" ? (
        <span>&mdash;</span>
      ) : (
        <span className={classes.label} title={formattedValue}>
          {formattedValue}&nbsp;
        </span>
      )}
      <RelicsIcon />
    </span>
  );
};
